import React, { Component } from "react";
import { Form, Table, Col, Image } from "react-bootstrap";

import MenuItem from "@material-ui/core/MenuItem";
import { FormControl, Select, InputLabel } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import Pagination from "rc-pagination";
import { RightSideCountTop } from "../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";

function SuperAdminOrderSettlementReport(props) {
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="Reports" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">Settlement Report</div>
              </div>
              <div className="row">
                <div className="col-4">
                  <div className="row">
                    <div className="col-3">
                      <Image
                        src={require("../../../../assets/images/UserManagement/fhr7.png")}
                        alt="View"
                        title="View"
                        fluid
                        className="w-100 h-100"
                      />
                    </div>
                    <div className="col-9">
                      <div className="pl-3">
                        <div className="f24-500">Mc Donald’s Review</div>
                        <div className="f14-400">
                          84/36, N Main Rd, Koregaon Park Annexe Mundhwa, Pune,
                          Maharashtra 411001
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-8">
                  <div className="d-flex justify-content-end">
                    <RightSideCountTop
                      content={[
                        {
                          name: "No. Of Items",
                          value: "500",
                          backgroundColor: "#FFEDE9",
                          color: "#EE3A23",
                        },
                        {
                          name: (
                            <>
                              Refund/Cancellation <br />
                              /Substitution
                            </>
                          ),
                          value: "₹ 1,050",
                          backgroundColor: "#EFEBFB",
                          color: "#6F32C9",
                        },
                        {
                          name: "Order Total Amount",
                          value: "₹ 14,125.00",
                          backgroundColor: "#D8F3F4",
                          color: "#138B90",
                        },
                      ]}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    // onChange={props.onChange}
                    // value={props.search}
                    className="amSearch"
                  />
                </div>
                <div className="col-3"></div>
                <div className="col-3">
                  <div className="mr-3">
                    <FormControl variant="outlined" fullWidth>
                      <InputLabel id="demo-simple-select-outlined-label">
                        Select date range
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={""}
                        onChange={() => {}}
                        label="date_range"
                      >
                        <MenuItem value="">Last 30 days</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className="col-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="f10-400" align="center">
                      <img
                        src={require("../../../../assets/images/iconButton/sorticon.png")}
                        width="35px"
                      />
                      <br />
                      Sort
                    </div>
                    <div className="f10-400" align="center">
                      <img
                        src={require("../../../../assets/images/iconButton/filtericon.png")}
                        width="35px"
                      />
                      <br />
                      Filter
                    </div>
                    <div className="f10-400" align="center">
                      <img
                        src={require("../../../../assets/images/iconButton/downloadicon.png")}
                        width="35px"
                      />
                      <br />
                      Download
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                  <Table className="HideShowTable enMinWidth900">
                    <thead>
                      <tr className="super_admin_all_users_table_head">
                        <th style={{ width: "300px" }} className="f12-700">
                          Order Type/ <br />
                          Order ID
                        </th>
                        <th style={{ width: "278px" }} className="f12-700">
                          Order Status <br />
                          /Date & Time
                        </th>
                        <th style={{ width: "236px" }} className="f12-700">
                          No of <br />
                          Items
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Order <br />
                          Total
                        </th>
                        <th style={{ width: "250px" }} className="f12-700">
                          Sales <br />
                          Tax
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Surcharges
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          {/* <Form.Check
                              label="1"
                              inline
                              className="enCheckBoxOnly"
                            /> */}
                          CC <br />
                          Charges
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Net <br />
                          Remitted
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Discount
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Tip
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Donation
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Payment Status <br />
                          /Date & Time
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Payment Method/ <br />
                          Transaction ID
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Refund/
                          <br /> Cancellation
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Substitution
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Refund or Cancellation
                          <br /> Status/ID
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Remittance
                          <br /> Status/ID
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Merchant Account
                          <br /> No. & IFSC
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Settlement Date
                          <br /> & Time
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="super_admin_all_users_table_body">
                        <td style={{ width: "10%" }} className="f12-500">
                          Takeaway
                          <br />
                          1245789632
                        </td>

                        <td style={{ width: "10%" }} className="f12-500">
                          <div className="badge badge-success p-1">
                            Completed
                          </div>
                          <div className="f10-400">
                            25th Aug, 2020 <br />
                            09:15 PM
                          </div>
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                          3
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                          ₹ 570
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                          ₹ 520
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                          ₹ 52
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                          -
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                          ₹ 50
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                          ₹ 50
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                          ₹ 50
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                          ₹ 50
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                          <div className="badge badge-success p-1">Paid</div>
                          <div className="f10-400">
                            25th Aug, 2020 <br />
                            09:15 PM
                          </div>
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                          Debit Card
                          <div className="f10-400">1245789632</div>
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                          ₹ 50
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                          -
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                          <div className="f12-500">Successful</div>
                          <div className="f10-400">1245789632</div>
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                          <div className="badge badge-success p-1">Settled</div>
                          <div className="f10-400">1245789632</div>
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                          1234578912345678900/ <br />
                          SBIN00004412
                        </td>
                        <td style={{ width: "10%" }} className="f12-500">
                          25th Aug, 2020 <br />
                          09:15 PM
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>

              <div className="p4v2-menu-pagination">
                <Pagination
                  onChange={() => {}}
                  current={1}
                  defaultPageSize={10}
                  total={15}
                  showTitle={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default SuperAdminOrderSettlementReport;
